import './translate.module';
import './translate.config';
